import { useState } from "react";

function EarningCalculator() {
  const [cups, setCups] = useState(500);

  const monthlyCups = cups * 30;
  const revenue = monthlyCups * 10;
  const cost = monthlyCups * 5;
  const gross = revenue - cost;
  const expenses = Math.max(12000, 31000 + (cups - 500) * 30);
  const net = gross - expenses;

  const formatINR = (n) => "₹" + Math.round(n).toLocaleString("en-IN");

  return (
    <section id="calculator">
      <div className="container">
        <div className="p-lg-8 p-7 rounded-5 bg-primary">
          <div className="row align-items-center g-4">
            <div className="col-lg-5">
              <span className="text-uppercase text-warning fw-semibold ls-md">
                Smart Earning Calculator
              </span>
              <h2 className="lh-1 mb-3 text-white">
                See Your Potential, Cup By Cup
              </h2>
              <p className="fs-4 lh-sm mb-4 text-light">
                Move the slider to match your expected daily footfall, modelled
                directly on Tikasa's own franchise projections.
              </p>
              <div className="d-flex gap-2 mb-4">
                <button
                  type="button"
                  className={
                    "btn rounded-4 px-5 " +
                    (cups === 500 ? "btn-warning" : "btn-outline-light")
                  }
                  onClick={() => setCups(500)}
                >
                  500 cups/day
                </button>
                <button
                  type="button"
                  className={
                    "btn rounded-4 px-5 " +
                    (cups === 1000 ? "btn-warning" : "btn-outline-light")
                  }
                  onClick={() => setCups(1000)}
                >
                  1,000 cups/day
                </button>
              </div>
              <label className="d-flex justify-content-between fw-semibold mb-1">
                <span className="text-white fw-normal">Daily Cups Sold</span>
                <span className="text-white fw-normal">
                  {cups.toLocaleString("en-IN")}
                </span>
              </label>
              <input
                type="range"
                className="form-range"
                min="200"
                max="1500"
                step="25"
                value={cups}
                onChange={(e) => setCups(parseInt(e.target.value))}
              />
            </div>

            <div className="col-lg-7">
              <div className="row g-2">
                <div className="col-6">
                  <div className="bg-white rounded-4 py-4 px-5 h-100">
                    <p className="text-secondary mb-0 fs-5 lh-sm">
                      Monthly Revenue
                    </p>
                    <h3 className="mb-0 text-dark">{formatINR(revenue)}</h3>
                  </div>
                </div>
                <div className="col-6">
                  <div className="bg-white rounded-4 py-4 px-5 h-100">
                    <p className="text-secondary mb-0 fs-5 lh-sm">
                      Production Cost
                    </p>
                    <h3 className="mb-0 text-dark">{formatINR(cost)}</h3>
                  </div>
                </div>
                <div className="col-6">
                  <div className="bg-white rounded-4 py-4 px-5 h-100">
                    <p className="text-secondary mb-0 fs-5 lh-sm">
                      Monthly Expenses
                    </p>
                    <h3 className="mb-0 text-dark">{formatINR(expenses)}</h3>
                  </div>
                </div>
                <div className="col-6">
                  <div className="bg-warning rounded-4 py-4 px-5 h-100">
                    <p className="text-dark mb-0 fs-5 lh-sm">
                      Net Profit / Month
                    </p>
                    <h3 className="mb-0 text-dark">{formatINR(net)}</h3>
                  </div>
                </div>
                <div className="col-12">
                  <div className="bg-white rounded-4 py-4 px-5 text-center">
                    <p className="text-secondary mb-0 fs-5 lh-sm">
                      Projected Net Profit / Year
                    </p>
                    <h3 className="mb-0 text-dark">{formatINR(net * 12)}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function VisionMission() {
  const missionPoints = [
    {
      icon: "bi-megaphone-fill",
      text: "Generate mass awareness about the proven health benefits of jaggery-based beverages over conventional sugar tea.",
    },
    {
      icon: "bi-diagram-3-fill",
      text: "Build a robust pan-India franchise network delivering consistent quality, taste and service at every outlet.",
    },
    {
      icon: "bi-graph-up-arrow",
      text: "Create a profitable, low-investment opportunity for entrepreneurs, especially in Tier 2 and Tier 3 cities.",
    },
  ];

  return (
    <section className="py-7">
      <div className="container">
        <div className="row g-4 align-items-stretch">
          <div className="col-lg-5">
            <div className="bg-primary rounded-4 p-8 h-100 d-flex flex-column justify-content-center">
              <span className="text-uppercase text-warning fw-medium fs-4">
                Our Vision
              </span>
              <h2 className="fw-normal ls-sm text-white lh-1 mt-2">
                India's Most Loved Jaggery Tea &amp; Street Food Brand
              </h2>
              <p className="text-light lh-sm mt-3 mb-0 fs-4">
                We envision Tikasa Amruttulya empowering entrepreneurs across
                every city, town and locality to serve a healthier, tastier, and
                more authentic cup of chai alongside the iconic Vadapav —
                without compromising on quality, taste, or affordability.
              </p>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="mb-3">
              <span className="text-uppercase text-primary fw-semibold ls-md ms-4">
                Our Mission
              </span>
            </div>
            <div className="d-flex flex-column gap-1">
              {missionPoints.map((point, i) => (
                <div
                  className="d-flex align-items-center shadow border border-light rounded-pill py-3 ps-3 pe-5 hover-lift bg-primary"
                  key={i}
                >
                  <div className="icon-shape icon-xl bg-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
                    <i className={`bi ${point.icon} fs-3 text-primary`}></i>
                  </div>
                  <p className="mb-0 ms-4 lh-sm text-light fs-5">
                    {point.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FranchiseModelSummary() {
  const items = [
    {
      num: "01",
      icon: "bi-wallet2",
      bg: "bg-light-primary",
      title: "Total Investment",
      desc: "Rs. 2 – 3 Lakhs, depending on location & setup.",
    },
    {
      num: "02",
      icon: "bi-file-earmark-text-fill",
      bg: "bg-warning-subtle",
      title: "Franchise Fee — 5 Years, Renewable",
      desc: "Rs. 50,000 + 18% GST, non-refundable.",
    },
    {
      num: "03",
      icon: "bi-rulers",
      bg: "bg-danger-subtle",
      title: "Floor Space Required",
      desc: "80 – 150 sq. ft. with good visibility & footfall.",
    },
    {
      num: "04",
      icon: "bi-shield-check",
      bg: "bg-light-primary",
      title: "Zero Royalty Fees",
      desc: "Keep more of what you earn, every single month.",
    },
    {
      num: "05",
      icon: "bi-clipboard-check",
      bg: "bg-warning-subtle",
      title: "Licenses Required",
      desc: "FSSAI Registration, Shop & Establishment Act, GST.",
    },
  ];

  return (
    <section className="py-7" id="franchise">
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-md-12 px-lg-8">
            <span className="text-uppercase text-primary fw-semibold ls-md">
              Get Started
            </span>
            <h2 className="fw-normal ls-sm lh-1">Franchise Model Summary</h2>
            <p className="lh-sm mt-3 fs-4">
              Designed for simplicity, scalability and success — here is
              everything you need to know to get started.
            </p>
          </div>
        </div>
        <div className="row g-2 justify-content-center">
          {items.map((item) => (
            <div className="col-lg-4 col-6" key={item.num}>
              <div className="position-relative overflow-hidden shadow bg-warning border border-light rounded-4 p-4 h-100 hover-lift">
                <span
                  className="position-absolute top-0 end-0 display-2 fw-bold text-primary pe-3 pt-3 lh-1"
                  style={{ opacity: 0.08 }}
                >
                  {item.num}
                </span>
                <div
                  className={`icon-shape icon-xl bg-white rounded-circle d-flex align-items-center justify-content-center mb-3 position-relative`}
                >
                  <i className={`bi ${item.icon} fs-3 text-primary`}></i>
                </div>
                <h3 className="mb-1 lh-1 fs-4 text-dark position-relative">
                  {item.title}
                </h3>
                <p className="text-dark lh-sm mb-0 position-relative">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function UniqueSellingPoints() {
  const items = [
    { icon: "bi-briefcase", bg: "bg-light-primary", title: "Own R&D" },
    {
      icon: "bi-truck",
      bg: "bg-warning-subtle",
      title: "Strong Supply Chain Management",
    },
    {
      icon: "bi-arrow-left-right",
      bg: "bg-danger-subtle",
      title: "Instore Cross-Selling Strategies",
    },
    {
      icon: "bi-people-fill",
      bg: "bg-light-primary",
      title: "Staff Requirement & Training",
    },
    {
      icon: "bi-shield-fill-check",
      bg: "bg-warning-subtle",
      title: "Less Risk, High Profit",
    },
    {
      icon: "bi-box-seam-fill",
      bg: "bg-danger-subtle",
      title: "Standard Inventory",
    },
  ];

  return (
    <section className="pt-7" id="edge">
      <div className="container">
        <div className="row mb-5 align-items-end g-4">
          <div className="col-lg-6">
            <span className="text-uppercase text-primary fw-semibold ls-md">
              Our Edge
            </span>
            <h2 className="fw-normal ls-sm lh-1">Unique Selling Points</h2>
          </div>
          <div className="col-lg-6">
            <p className="lh-sm fs-4 mb-0 ls-sm">
              Tikasa Amruttulya is a fast-growing Indian food and beverage
              franchise built on authenticity, quality, and a proven business
              model.
            </p>
          </div>
        </div>
        <div className="row g-2">
          {items.map((item) => (
            <div className="col-lg-4 col-6" key={item.title}>
              <div className="shadow rounded-pill p-3 h-100 hover-lift bg-warning border border-light d-flex align-items-center">
                <div
                  className={`icon-shape icon-xl bg-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0`}
                >
                  <i className={`bi ${item.icon} fs-3 text-primary`}></i>
                </div>
                <h3 className="mb-0 ms-lg-4 ms-3 lh-1 fs-lg-4 fs-5 text-dark ls-sm">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function StepsToOwnership() {
  const steps = [
    {
      title: "Submit Franchise Application",
      desc: "Share your details and preferred location to get started.",
      icon: "bi-file-earmark-text",
      bg: "bg-light-primary",
    },
    {
      title: "Review Disclosure Documents",
      desc: "Go through the franchise terms, fees and expectations.",
      icon: "bi-clipboard-check",
      bg: "bg-warning-subtle",
    },
    {
      title: "Meet the Tikasa Team",
      desc: "Discuss your goals with us and get your questions answered.",
      icon: "bi-people-fill",
      bg: "bg-danger-subtle",
    },
    {
      title: "Conduct Local Research",
      desc: "Validate footfall and demand for your chosen location.",
      icon: "bi-search",
      bg: "bg-light-primary",
    },
    {
      title: "Secure Financing",
      desc: "Arrange the capital needed for setup and launch.",
      icon: "bi-cash-coin",
      bg: "bg-warning-subtle",
    },
    {
      title: "Sign Franchise Agreement",
      desc: "Formalise the partnership for a 5-year renewable term.",
      icon: "bi-pen",
      bg: "bg-danger-subtle",
    },
    {
      title: "Secure Location & Build Outlet",
      desc: "Finalise your 80–150 sq. ft. space and set up the counter.",
      icon: "bi-geo-alt-fill",
      bg: "bg-light-primary",
    },
    {
      title: "Attend Training",
      desc: "Learn recipes, service standards and hygiene protocols.",
      icon: "bi-mortarboard-fill",
      bg: "bg-warning-subtle",
    },
    {
      title: "Celebrate Grand Opening",
      desc: "Open your doors and start serving Gud Ki Chai.",
      icon: "bi-stars",
      bg: "bg-danger-subtle",
    },
  ];

  return (
    <section className="pb-7 pt-5" id="steps">
      <div className="container mb-3">
        <div className="row mb-5">
          <div className="col-12">
            <span className="text-uppercase text-primary fw-semibold ls-md">
              Get Started
            </span>
            <h2 className="lh-1 mb-0">Steps to Ownership</h2>
            <p className="lh-sm fs-4 mt-2 mb-0">
              Nine simple steps stand between you and your own Tikasa Amruttulya
              outlet.
            </p>
          </div>
        </div>
        <div className="row g-2">
          {steps.map((step, i) => (
            <div className="col-lg-4 col-6" key={step.title}>
              <div className="position-relative overflow-hidden shadow bg-warning rounded-4 h-100 hover-lift p-5">
                <span
                  className="position-absolute top-0 end-0 display-1 fw-bold text-light pe-3 pt-3 lh-1"
                  style={{ opacity: 0.07 }}
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div
                  className={`icon-shape icon-xl bg-white rounded-circle d-flex align-items-center justify-content-center mb-3 position-relative`}
                >
                  <i className={`bi ${step.icon} fs-3 text-primary`}></i>
                </div>
                <span className="text-white fw-semibold text-uppercase ls-md fs-6 position-relative d-block mb-1">
                  Step {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mb-1 lh-1 fs-4 text-primary position-relative">
                  {step.title}
                </h3>
                <p className="text-dark lh-sm mb-0 position-relative">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function GetInTouch() {
  return (
    <section id="get-in-touch" className="mb-n1">
      <div className="container mt-2">
        <div className="bg-primary rounded-top-5 p-lg-7 p-5 pb-5 position-relative overflow-hidden">
          <div className="row align-items-center g-lg-7 g-5">
            <div className="col-lg-6">
              <div className="ps-lg-5 pe-lg-8 me-6">
                <span className="text-uppercase text-white fw-medium fs-4">
                  Contact Us
                </span>
                <h2 className="fw-normal ls-sm text-warning lh-1 mt-2">
                  Let's Grow Together
                </h2>
                <p className="text-white lh-sm mt-3 fs-4">
                  When you grow, we grow. Partner with Tikasa Amruttulya and
                  build a profitable future backed by a brand that stands by you
                  at every step.
                </p>
                <a
                  href="#contact"
                  className="btn btn-light fw-normal px-6 mt-3 mb-4 rounded-pill"
                >
                  Become a Franchise Partner
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="bg-white rounded-5 p-lg-7 p-5 h-100">
                <div className="d-flex align-items-start mb-4">
                  <div className="icon-shape icon-xl bg-light-primary rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
                    <i className="bi bi-telephone-fill fs-3 text-primary"></i>
                  </div>
                  <div className="ms-4">
                    <p className="text-secondary mb-1 fs-6 text-uppercase fw-semibold ls-md">
                      Phone Number
                    </p>
                    <p className="mb-0 fs-5 text-dark lh-sm ls-sm">
                      <a
                        href="tel:+919921111101"
                        className="text-dark text-decoration-none"
                      >
                        +91 9921111101
                      </a>
                      ,{" "}
                      <a
                        href="tel:+918805556262"
                        className="text-dark text-decoration-none"
                      >
                        +91 8805556262
                      </a>
                      <br />
                      <a
                        href="tel:+918789385315"
                        className="text-dark text-decoration-none"
                      >
                        +91 8789385315
                      </a>
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-start mb-4">
                  <div className="icon-shape icon-xl bg-warning-subtle rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
                    <i className="bi bi-globe fs-3 text-primary"></i>
                  </div>
                  <div className="ms-4">
                    <p className="text-secondary mb-1 fs-6 text-uppercase fw-semibold ls-md">
                      Website
                    </p>
                    <p className="mb-0 fs-5 text-dark ls-sm">
                      <a
                        href="https://www.tikasaamruttulya.com"
                        target="_blank"
                        rel="noreferrer"
                        className="text-dark text-decoration-none"
                      >
                        www.tikasaamruttulya.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-start mb-1">
                  <div className="icon-shape icon-xl bg-danger-subtle rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
                    <i className="bi bi-geo-alt-fill fs-3 text-primary"></i>
                  </div>
                  <div className="ms-4">
                    <p className="text-secondary mb-1 fs-6 text-uppercase fw-semibold ls-md">
                      Location
                    </p>
                    <p className="mb-0 fs-5 text-dark lh-sm ls-sm">
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=Rais+Aaragya+Building+Kalyan+East+Thane+Maharashtra"
                        target="_blank"
                        rel="noreferrer"
                        className="text-dark text-decoration-none"
                      >
                        Rais Aaragya Building no. 3, office no. 8, C wing,
                        Kalyan East – 421306, Thane, Maharashtra
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Home() {
  return (
    <>
      <section id="home" className="mt-n1">
        <div className="container d-lg-block d-none">
          <img
            src="/assets/images/hero.png"
            className="w-100 object-fit-contain rounded-bottom-5"
          />
        </div>
        <div className="container d-lg-none d-block">
          <img
            src="/assets/images/hero-s.png"
            className="w-100 object-fit-contain rounded-bottom-5"
          />
        </div>
      </section>

      <section className="py-7 mb-2" id="about">
        <div className="container">
          <div className="text-center">
            <h5 className="lh-1 mb-2 fs-3 text-danger fw-normal ls-sm">
              <p className="text-dark fw-semibold text-uppercase mb-2">
                Tikasa Amruttulya — Jaggery Tea &amp; Mumbai Vadapav Franchise
              </p>
              Maharashtra's most-loved Gud Ki Chai, now a low-investment
              <br />
              franchise opportunity for entrepreneurs across India.
            </h5>
          </div>
          <div className="row gy-4 gy-lg-0 mt-6">
            <div className="col-lg-7 col-12 pe-lg-8">
              <div className="mb-5">
                <h2 className="fw-medium ls-sm lh-1">
                  Tea As Precious As Nectar, Built Into a Franchise
                </h2>
                <p className="mb-0 lh-sm fs-4">
                  The name <u>Tikasa</u> stands for bold, distinctive flavour,
                  while <u>Amruttulya</u> honours the timeless tradition of
                  serving tea as precious as nectar. We bring together
                  Maharashtra's signature Jaggery Tea (Gud Ki Chai) and
                  authentic Mumbai Vadapav under one proven business model.
                </p>
              </div>
              <div className="mb-3 bg-light p-5 rounded-4">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <h3 className="mb-0">Find Your Perfect Chai Partner</h3>
                </div>
                <p className="mb-0 lh-sm fs-4">
                  Driven by innovation, operational excellence and
                  entrepreneurial growth, we hand franchise partners a scalable
                  business rooted in traditional Indian flavours — backed by
                  full setup support and staff training.
                </p>
              </div>
              <a
                href="#directors"
                className="mb-0 ms-2 text-primary text-decoration-none"
              >
                <h3 className="mb-0 d-inline">— Our Directors</h3>
              </a>
            </div>
            <div className="col-lg-5">
              <img
                src="/assets/images/3.jpeg"
                alt="Tikasa jaggery tea"
                className="img-fluid rounded-4 object-fit-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container d-lg-block d-none">
          <img
            src="/assets/images/3.png"
            className="w-100 object-fit-contain rounded-5"
          />
        </div>
        <div className="container d-lg-none d-block">
          <img
            src="/assets/images/3-s.png"
            className="w-100 object-fit-contain rounded-5"
          />
        </div>
      </section>

      <VisionMission />

      <section id="why-tikasa">
        <div className="container">
          <div className="py-7 px-5 gradient-section-2 rounded-4">
            <div className="row text-center">
              <div className="col-md-12 px-8">
                <span className="text-uppercase text-white fw-medium fs-4">
                  Why Choose Tikasa Amruttulya
                </span>
                <h2 className="fw-normal ls-sm text-white lh-1">
                  A Complete Franchise Experience, Not Just a Tea Stall
                </h2>
                <p className="lh-sm mt-3">
                  Tikasa brings together two of Maharashtra's most popular food
                  &amp; beverage categories under one trusted, supported brand —
                  built for first-time
                  <br />
                  entrepreneurs and seasoned operators alike.
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <div className="col-lg-9 col-12 mt-4">
                <div className="row g-2 justify-content-center align-items-center">
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white h-100">
                      <div className="d-flex align-items-center py-1">
                        <div className="icon-shape icon-xl bg-light-primary rounded-circle position-absolute">
                          <i className="bi bi-stack fs-3 text-primary"></i>
                        </div>
                        <div className="ms-8 ps-3">
                          <h3 className="mb-0 text-dark lh-1 fs-4">
                            Dual-Product Model
                          </h3>
                          <p className="text-secondary lh-1 mt-1 mb-0">
                            Jaggery Tea and Mumbai Vadapav
                            <br className="d-lg-block d-none" /> under one
                            counter.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white h-100">
                      <div className="d-flex align-items-center py-1">
                        <div className="icon-shape icon-xl bg-light-primary rounded-circle position-absolute">
                          <i className="bi bi-graph-up-arrow fs-3 text-primary"></i>
                        </div>
                        <div className="ms-8 ps-3">
                          <h3 className="mb-0 text-dark lh-1 fs-4">
                            Low Investment, High Returns
                          </h3>
                          <p className="text-secondary lh-1 mt-1 mb-0">
                            Capital-light outlets designed
                            <br className="d-lg-block d-none" /> to earn
                            quickly.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white h-100">
                      <div className="d-flex align-items-center py-1">
                        <div className="icon-shape icon-xl bg-light-primary rounded-circle position-absolute">
                          <i className="bi bi-shield-check fs-3 text-primary"></i>
                        </div>
                        <div className="ms-8 ps-3">
                          <h3 className="mb-0 text-dark lh-1 fs-4">
                            Zero Royalty Fees
                          </h3>
                          <p className="text-secondary lh-1 mt-1 mb-0">
                            Keep more of what you
                            <br className="d-lg-block d-none" /> earn, every
                            month.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white h-100">
                      <div className="d-flex align-items-center py-1">
                        <div className="icon-shape icon-xl bg-light-primary rounded-circle position-absolute">
                          <i className="bi bi-person-check-fill fs-3 text-primary"></i>
                        </div>
                        <div className="ms-8 ps-3">
                          <h3 className="mb-0 text-dark lh-1 fs-4">
                            Complete Staff Training
                          </h3>
                          <p className="text-secondary lh-1 mt-1 mb-0">
                            Recipes, service and hygiene
                            <br className="d-lg-block d-none" /> before opening
                            day.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white h-100">
                      <div className="d-flex align-items-center py-1">
                        <div className="icon-shape icon-xl bg-light-primary rounded-circle position-absolute">
                          <i className="bi bi-gear-fill fs-3 text-primary"></i>
                        </div>
                        <div className="ms-8 ps-3">
                          <h3 className="mb-0 text-dark lh-1 fs-4">
                            End-to-End Setup Support
                          </h3>
                          <p className="text-secondary lh-1 mt-1 mb-0">
                            From paperwork to first
                            <br className="d-lg-block d-none" /> pour.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white h-100">
                      <div className="d-flex align-items-center py-1">
                        <div className="icon-shape icon-xl bg-light-primary rounded-circle position-absolute">
                          <i className="bi bi-palette2 fs-3 text-primary"></i>
                        </div>
                        <div className="ms-8 ps-3">
                          <h3 className="mb-0 text-dark lh-1 fs-4">
                            Interior &amp; Store Design
                          </h3>
                          <p className="text-secondary lh-1 mt-1 mb-0">
                            Branded design support for
                            <br className="d-lg-block d-none" /> every outlet.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white h-100">
                      <div className="d-flex align-items-center py-1">
                        <div className="icon-shape icon-xl bg-light-primary rounded-circle position-absolute">
                          <i className="bi bi-lightbulb-fill fs-3 text-primary"></i>
                        </div>
                        <div className="ms-8 ps-3">
                          <h3 className="mb-0 text-dark lh-1 fs-4">
                            Continuous Product Innovation
                          </h3>
                          <p className="text-secondary lh-1 mt-1 mb-0">
                            A menu that keeps
                            <br className="d-lg-block d-none" /> evolving.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white h-100">
                      <div className="d-flex align-items-center py-1">
                        <div className="icon-shape icon-xl bg-light-primary rounded-circle position-absolute">
                          <i className="bi bi-clock-history fs-3 text-primary"></i>
                        </div>
                        <div className="ms-8 ps-3">
                          <h3 className="mb-0 text-dark lh-1 fs-4">
                            Years of Tea Expertise
                          </h3>
                          <p className="text-secondary lh-1 mt-1 mb-0">
                            Behind 250+ jaggery-tea
                            <br className="d-lg-block d-none" /> outlets
                            nationwide.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FranchiseModelSummary />

      <section className="py-3 mb-6" id="products">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12">
              <div className="d-flex flex-column gap-2">
                <h2 className="mb-0 ls-sm lh-1">Our Menu</h2>
                <p className="m-0 lh-1 lead fw-normal mt-n2">
                  Ten signature items, anchored by world-renowned{" "}
                  <u>Jaggery Tea</u>.
                </p>
              </div>
            </div>
          </div>
          <div className="row g-2">
            <div className="col-lg-4">
              <div className="row g-0 shadow rounded-4 h-100 hover-lift">
                <div className="col-12">
                  <div className="bg-warning-soft card-image-section rounded-top-5 d-flex justify-content-center align-items-center py-2 h-100">
                    <img
                      src="/assets/images/1.png"
                      alt="Jaggery Teas"
                      width="180"
                    />
                  </div>
                </div>
                <div className="col-12 px-4 d-flex align-items-center border pb-4 pt-1 border-1 rounded-bottom-5 border-top-0">
                  <div className="d-flex flex-column px-2 mb-2">
                    <div className="d-flex flex-column gap-3 mt-4">
                      <div className="d-flex flex-column">
                        <h3 className="mb-0 lh-1 fs-3 text-dark">
                          Jaggery Teas
                        </h3>
                        <p className="mb-0 lh-1 mt-1 mb-2">
                          Six naturally sweetened blends, never refined.
                        </p>
                        <p className="mt-2 mb-0 lh-sm">
                          <div className="row">
                            <div className="col-6">
                              <ul className="ps-3">
                                <li>Jaggery Plain Tea</li>
                                <li>Jaggery Cardamom Tea</li>
                                <li>Jaggery Lemongrass Tea</li>
                              </ul>
                            </div>
                            <div className="col-6">
                              <ul className="ps-3">
                                <li>Jaggery Ginger Tea</li>
                                <li>Jaggery Masala Tea</li>
                                <li>Jaggery Lemon Tea</li>
                              </ul>
                            </div>
                          </div>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="row g-0 shadow rounded-4 h-100 hover-lift">
                <div className="col-12">
                  <div className="position-relative">
                    <div className="bg-light rounded-top-5 card-image-section d-flex h-100 justify-content-center align-items-center py-2">
                      <img
                        src="/assets/images/coffee.png"
                        alt="Jaggery Coffee"
                        width="180"
                      />
                    </div>
                    <div className="position-absolute bottom-0 left-0 p-3 ms-3">
                      <span className="badge text-bg-white fs-5 fst-italic px-4 rounded-pill">
                        Naturally Sweet
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12 px-4 d-flex align-items-center border pb-4 pt-1 border-1 rounded-bottom-5 border-top-0">
                  <div className="d-flex flex-column px-2 mb-2">
                    <div className="d-flex flex-column gap-3 mt-4">
                      <div className="d-flex flex-column">
                        <h3 className="mb-0 lh-1 fs-3 text-dark">
                          Jaggery Coffee
                        </h3>
                        <p className="mb-0 lh-1 mt-1 mb-2">
                          Our daily-brew coffee, sweetened the Tikasa way — with
                          jaggery instead of refined sugar.
                        </p>
                        <p className="mt-2 mb-0 lh-sm">
                          <div className="row">
                            <div className="col-12">
                              <ul className="ps-3">
                                <li>Naturally sweetened, no added sugar</li>
                                <li>Brewed fresh, served hot</li>
                                <li>Pairs perfectly with Vadapav</li>
                              </ul>
                            </div>
                          </div>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="row g-0 shadow rounded-4 h-100 hover-lift">
                <div className="col-12">
                  <div className="position-relative">
                    <div className="bg-danger-subtle card-image-section rounded-top-5 h-100 d-flex justify-content-center align-items-center py-2">
                      <img
                        src="/assets/images/vada.png"
                        alt="Jaggery Coffee"
                        width="180"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 px-4 d-flex align-items-center border pb-4 pt-1 border-1 rounded-bottom-5 border-top-0">
                  <div className="d-flex flex-column px-2 mb-2">
                    <div className="d-flex flex-column gap-3 mt-4">
                      <div className="d-flex flex-column">
                        <h3 className="mb-0 lh-1 fs-3 text-dark">
                          Vadapav &amp; Snacks
                        </h3>
                        <p className="mb-0 lh-1 mt-1 mb-2">
                          Authentic Mumbai street food, made for cross-selling
                          alongside every cup.
                        </p>
                        <p className="mt-2 mb-0 lh-sm">
                          <div className="row">
                            <div className="col-12">
                              <ul className="ps-3">
                                <li>Mumbai Vadapav</li>
                                <li>Jaggery Cream Roll</li>
                                <li>Jaggery Biscuits</li>
                              </ul>
                            </div>
                          </div>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <EarningCalculator />

      <UniqueSellingPoints />

      <section className="pt-3" id="ingredients">
        <div className="container py-7">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="position-relative d-flex justify-content-start align-items-end">
                <img
                  src="/assets/images/11.jpg"
                  alt="Kolhapuri jaggery sourcing"
                  className="w-100 object-fit-cover rounded-4 ms-lg-8 ms-0"
                  height="450"
                />
                <img
                  src="/assets/images/10.jpg"
                  alt="Cutting chai"
                  className="w-75 object-fit-cover rounded-4 position-absolute border object-position-top border-5 border-white mb-n8"
                  height="200"
                />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="d-flex flex-column gap-5 ps-lg-8 ms-lg-6">
                <div className="d-flex flex-column gap-2 mt-lg-0 mt-8 pt-lg-0 pt-5">
                  <span className="text-uppercase text-secondary fw-semibold ls-md">
                    Our Ingredients
                  </span>
                  <h2 className="lh-1">Anchored by Jaggery</h2>
                  <p className="mb-2 fs-4 lh-sm fst-italic text-danger">
                    Naturally sweetened. Never refined.
                  </p>
                  <p className="mb-0 fs-4 lh-sm">
                    Every product at <u>Tikasa Amruttulya</u> is crafted with
                    natural, quality ingredients — anchored by world-renowned{" "}
                    <u>Jaggery</u>. Our menu is built to delight every palate,
                    across every occasion.
                    <br />
                    <br />
                    It's a small swap with a big difference — one that customers
                    taste, and keep coming back for.
                  </p>

                  <div className="d-flex flex-column align-items-start">
                    <a
                      href="#contact"
                      className="btn btn-primary fw-normal px-6 mt-4 rounded-pill"
                    >
                      Become a Franchise Partner
                    </a>
                    <a
                      href="tel:+919921111101"
                      className="ms-5 fs-5 text-dark fw-normal mt-2 rounded-pill"
                    >
                      <i className="bi bi-telephone me-1"></i> Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-6" id="directors">
        <div className="container d-flex flex-column align-items-center">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <span className="text-uppercase text-secondary fw-semibold ls-md">
                Leadership
              </span>
              <h2 className="lh-1 ls-sm">The People Behind the Passion</h2>
            </div>
          </div>
          <div className="col-lg-10 ">
            <div className="row g-1">
              <div className="col-lg-12">
                <div className="row g-0 rounded-4 h-100 hover-lift">
                  <div className="col-lg-4 col-12">
                    <img
                      src="/assets/images/director-1.png"
                      alt="Karna Bhingarde"
                      className="w-100 object-fit-cover object-position-top rounded-5 rounded-start-lg-pill"
                      height="320"
                    />
                  </div>
                  <div className="col-lg-8 col-12 ps-6 pe-8 d-flex align-items-center pb-4 pt-1 bg-primary rounded-5 rounded-end-lg-pill">
                    <div className="d-flex flex-column px-2 mb-2 mt-4">
                      <h3 className="mb-0 lh-1 fs-3 text-white">
                        Karna Bhingarde
                      </h3>
                      <p className="text-warning mb-2">Director</p>
                      <p className="mb-0 lh-sm text-light">
                        An engineer-turned-entrepreneur, he has led the
                        successful expansion of 250+ Tesstea Jaggery Tea outlets
                        across Maharashtra, Karnataka, Andhra Pradesh, and
                        Telangana. With a deep understanding of consumer
                        preferences and scalable franchise models, he has helped
                        build one of India's fastest-growing jaggery tea brands.
                        <br />
                        <br />
                        Driven by innovation, quality, and a passion for
                        creating sustainable food and beverage businesses, he is
                        now leading Tikasa with a vision to redefine tea
                        experiences and build a nationally recognized brand.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="row g-0 rounded-4 h-100 hover-lift">
                  <div className="col-lg-4 col-12">
                    <img
                      src="/assets/images/director-2.png"
                      alt="Atma Prakash Singh"
                      className="w-100 object-fit-cover object-position-top rounded-5 rounded-start-lg-pill"
                      height="320"
                    />
                  </div>
                  <div className="col-lg-8 col-12 ps-6 pe-8 d-flex align-items-center pb-4 pt-1 bg-primary rounded-5 rounded-end-lg-pill">
                    <div className="d-flex flex-column px-2 mb-2 mt-4">
                      <h3 className="mb-0 lh-1 fs-3 text-white">
                        Atma Prakash Singh
                      </h3>
                      <p className="text-warning mb-2">Director</p>
                      <p className="mb-0 lh-sm text-light">
                        Bringing over 30 years of experience across the FMCG,
                        OTC, and food industries, he has built a reputation for
                        driving growth through consumer-centric thinking and
                        strategic leadership. With a deep understanding of
                        Indian markets and evolving consumer behaviour.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="row g-0 rounded-4 h-100 hover-lift">
                  <div className="col-lg-4 col-12">
                    <img
                      src="/assets/images/director-3.png"
                      alt="Pankaj Kumar Tiwari"
                      className="w-100 object-fit-cover object-position-top rounded-5 rounded-start-lg-pill"
                      height="320"
                    />
                  </div>
                  <div className="col-lg-8 col-12 ps-6 pe-8 d-flex align-items-center pb-4 pt-1 bg-primary rounded-5 rounded-end-lg-pill">
                    <div className="d-flex flex-column px-2 mb-2 mt-4">
                      <h3 className="mb-0 lh-1 fs-3 text-white">
                        Pankaj Kumar Tiwari
                      </h3>
                      <p className="text-warning mb-2">Director</p>
                      <p className="mb-0 lh-sm text-light">
                        Pankaj Kumar Tiwari is an FMCG professional and
                        entrepreneur with over 2 decades of experience in India.
                        He specializes in business growth and has expertise in
                        retail and logistics with leading companies.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <StepsToOwnership />

      <section className="pb-8 bg-white" id="contact">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12 d-flex align-items-center">
              <div className="mb-4 mb-xl-0 text-center text-md-start">
                <span className="badge bg-danger-soft rounded-pill fs-5 px-4 mb-3">
                  Contact Us
                </span>
                <h1 className="display-5 fw-bold mb-3 ls-sm lh-1">
                  Get a Call Back
                </h1>
                <p className="mb-3 text-dark fs-4 lh-sm">
                  Have questions about starting your own outlet? Just share your
                  contact — our franchise team will call you and help you get
                  started in no time!
                </p>
                <p className="mb-3 fs-4 lh-sm">
                  Tikasa Amruttulya brings together Maharashtra's signature
                  Jaggery Tea (Gud Ki Chai) and authentic Mumbai Vadapav under
                  one proven, low-investment franchise model — with zero royalty
                  fees and complete setup support at every step.
                </p>
                <div className="mb-4 mb-0">
                  <ul className="list-unstyled fs-4">
                    {[
                      "Jaggery Tea & Vadapav",
                      "Zero Royalty Fees",
                      "Full Setup Support",
                    ].map((item) => (
                      <li key={item}>
                        <span className="me-2">
                          <i className="bi bi-star text-warning" />
                        </span>
                        <span className="align-text-top">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <a
                    href="#franchise"
                    className="btn btn-outline-dark rounded-pill px-5 btn-md mt-3 mb-lg-0 mb-5 me-2"
                  >
                    Tikasa's Franchise Model
                  </a>
                  <a
                    href="#about"
                    className="btn btn-warning px-5 rounded-pill btn-md mt-3 mb-lg-0 mb-5"
                  >
                    Know More
                  </a>
                </div>
              </div>
            </div>
            <div className="offset-xxl-1 col-xxl-5 col-lg-6 col-md-12">
              <div className="card smooth-shadow-md rounded-5 mt-lg-0 mt-4">
                <div className="card-body px-6 pt-5 pb-4">
                  <form className="needs-validation">
                    <div className="mb-2">
                      <input
                        type="email"
                        id="courseLeadEmail"
                        className="form-control rounded-pill px-4"
                        placeholder="Full Name"
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="email"
                        id="courseLeadEmail2"
                        className="form-control rounded-pill px-4"
                        placeholder="Phone No"
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="email"
                        id="courseLeadEmail3"
                        className="form-control rounded-pill px-4"
                        placeholder="Email"
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="password"
                        id="courseLeadPassword"
                        className="form-control rounded-pill px-4"
                        placeholder="Subject"
                      />
                    </div>
                    <div className="mb-2">
                      <textarea
                        type="text"
                        className="form-control rounded-4 px-4"
                        placeholder="Complete Address"
                        rows={2}
                        defaultValue={""}
                      />
                    </div>
                    <div className="d-grid">
                      <button
                        type="submit"
                        className="btn btn-primary rounded-pill"
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                      >
                        Send Message
                      </button>
                    </div>
                  </form>
                </div>
                <div className="card-footer rounded-5 px-6 py-4">
                  <p className="mb-0 text-center">
                    By continuing you accept the{" "}
                    <a
                      href="#"
                      className="text-dark fw-semibold text-decoration-underline"
                    >
                      Privacy Policy
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-7 bg-white" id="faq">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row text-center d-flex justify-content-center">
                <div className="col-lg-7 col-md-12 px-lg-8 mb-3">
                  <h2 className="fw-bold text-dark mb-0">
                    Here's everything you{" "}
                    <u className="text-dark">
                      <span className="text-dark">may ask?</span>
                    </u>
                  </h2>
                  <p className="lead text-dark opacity-75 lh-sm mt-2">
                    Got questions? Find all the answers here about Tikasa, our
                    franchise model, and the enrollment process.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-10 pb-lg-0 pb-3 d-flex align-items-center">
              <div
                className="accordion accordion-flush w-100"
                id="accordionFlushExample"
              >
                {[
                  {
                    id: "One",
                    q: "How much investment do I need to start a Tikasa Amruttulya franchise?",
                    a: "The total investment ranges between Rs. 2 – 3 Lakhs, depending on your location and setup requirements.",
                    open: true,
                    green: true,
                  },
                  {
                    id: "Two",
                    q: "What is the franchise fee, and how long does the agreement last?",
                    a: "The franchise fee is Rs. 50,000 + 18% GST (non-refundable), and the agreement is valid for 5 years, renewable thereafter.",
                    open: true,
                  },
                  {
                    id: "Three",
                    q: "Do I have to pay any royalty fees?",
                    a: "No. Tikasa Amruttulya charges zero royalty fees, so you keep more of what you earn every month.",
                  },
                  {
                    id: "Four",
                    q: "How much floor space do I need for an outlet?",
                    a: "You'll need 80 – 150 sq. ft. of space with good visibility and footfall — ideal for a compact, high-turnover counter.",
                  },
                  {
                    id: "Five",
                    q: "What licenses do I need before starting operations?",
                    a: "You'll need FSSAI Registration, a Shop & Establishment Act license, and GST Registration (if applicable) before commencing operations.",
                  },
                  {
                    id: "Six",
                    q: "Where do I source the tea masala and Vadapav masala from?",
                    a: "Our proprietary Jaggery Tea masala and Vadapav masala are supplied exclusively by Tikasa Amruttulya — franchisees are not permitted to source these from any third party, ensuring consistent taste and quality.",
                  },
                  {
                    id: "Seven",
                    q: "How much can I expect to earn every month?",
                    a: "Based on estimated projections, selling 500 cups/day can earn a net profit of around Rs. 44,000/month, while 1,000 cups/day can earn around Rs. 1,04,000/month. Actual results depend on location, footfall, and market conditions.",
                  },
                  {
                    id: "Eight",
                    q: "Will I get training and support before opening my outlet?",
                    a: "Yes. We provide complete staff training on recipes, service standards, and hygiene protocols, along with end-to-end setup support — from paperwork to your first pour.",
                  },
                  {
                    id: "Nine",
                    q: "Can I sell other brands' products at my Tikasa outlet?",
                    a: "No. It's mandatory to sell only Tikasa Amruttulya branded products at the outlet — no competing or third-party food/beverage products are allowed at the same counter.",
                  },
                  {
                    id: "Ten",
                    q: "What happens if I don't comply with the franchise terms?",
                    a: "The company reserves the right to terminate the franchise agreement in the event of repeated non-compliance, quality violation, or breach of terms.",
                  },
                ].map((item, idx) => (
                  <div key={item.id} className="accordion-item border-0 mt-2">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button px-0 ${item.green ? "bg-primary" : "bg-warning"} px-5 rounded-pill ${item.open ? "" : "collapsed"}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#flush-collapse${item.id}`}
                        aria-expanded={item.open ? "true" : "false"}
                      >
                        <h3
                          className={`fs-4 me-5 lh-sm ${item.green ? "text-white" : "text-dark"} fw-medium m-0 ls-sm py-1`}
                        >
                          {item.q}
                        </h3>
                      </button>
                    </h2>
                    <div
                      id={`flush-collapse${item.id}`}
                      className={`accordion-collapse collapse ${item.open ? "show" : ""}`}
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body px-5">
                        <p className="fs-4 fw-light mb-4 text-dark opacity-75 lh-sm">
                          {item.a}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <GetInTouch />
    </>
  );
}

export default Home;
